import { FC } from 'react';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

import { UploadErrorDetailsTable } from './components/UploadErrorDetailsTable/UploadErrorDetailsTable';
import { ColumnHeader, ErrorGroup } from './types';

export type UploadErrorModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  errorGroups: Array<ErrorGroup>;
  columnHeaders: Array<ColumnHeader>;
};

export const UploadErrorModal: FC<UploadErrorModalProps> = ({
  open,
  onClose,
  title,
  description,
  errorGroups,
  columnHeaders,
}) => {
  return (
    <Dialog as="div" transition className="relative z-50" open={open} onClose={onClose}>
      <DialogBackdrop transition className="fixed inset-0 bg-gray-500/75 duration-300 ease-out data-closed:opacity-0" />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative w-full max-w-4xl overflow-hidden rounded-lg bg-white text-left shadow-xl duration-300 ease-out data-closed:scale-95 data-closed:opacity-0 sm:my-8"
          >
            <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
              <DialogTitle as="h3" className="text-lg font-medium text-gray-900">
                {title}
              </DialogTitle>
              <button
                type="button"
                onClick={onClose}
                className="rounded-md text-gray-400 hover:text-gray-500 focus:outline-hidden"
              >
                <span className="sr-only">Close</span>
                <XMarkIcon className="size-6" />
              </button>
            </div>

            <div className="max-h-[60vh] overflow-y-auto px-6 py-4">
              <UploadErrorDetailsTable errorGroups={errorGroups} columnHeaders={columnHeaders} />
            </div>

            <div className="border-t border-gray-200 px-6 py-4">
              <p className="text-sm text-gray-500">{description}</p>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};
